import { PropsWithChildren } from 'react';

export const Container = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={`
        mx-auto w-full max-w-(--breakpoint-2xl) px-4
        lg:px-8
      `}
    >
      {children}
    </div>
  );
};
